import QRCode from 'qrcode'
import * as jsPDF from 'jspdf';


/// TO print cartonslip on secondary packing service
export default class PrintSecondaryPackagingServiceManualAll {

    genQR(text) {
        let qr = "";
        QRCode.toDataURL(text, function (err, url) {
            qr = url;
        });
        return qr;
    }
    formPreview1(resp) {
        let doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [130, 90],
            compressPdf: true
        });

        doc = this.printLblPrntContent1(doc, resp);
        doc.save(resp[0].CartonId + '.pdf');
        // window.open(doc.output('bloburl'), '_blank');
    }

    printLblPrntContent1(doc, resp) {
        debugger

        let i = 1;
        let j = 0;

        for (; i <= resp.length; i++) {
            // doc.setFontSize(7)
            doc.setFontType('bold');
            doc.setFont('Times');
            var loc = 0,
                inc = 3,
                docW = 2;
          
            
            doc.setFontSize(10);
            const Qr= `http://qr.tropicalagro.com/di-details?${resp[j].CartonId}`
            let qrdata = this.genQR(Qr);
            // doc.addImage(qrdata, 'JPEG', 16, 4, 16, 15, resp[j].CartonId, false);
            // doc.setFontSize(8);
            // doc.text(resp[j].ProductName, 1, 4);
        
            // const fromNoLast4Digits = resp[j].CartonId.substr(5);
            // doc.setFontSize(7);
            // doc.text(fromNoLast4Digits, 8, 20);
            // doc.setFontSize(7);
            // doc.text('BatchNo: ' + resp[0].BatchNo, 8, 25);
            doc.setFontSize(6); // Set the font size for the heading
            doc.text('PACKING SLIP', 15, 2); // Add the heading "Packing Slip"

            doc.addImage(qrdata, 'JPEG', 1, 13, 15, 15); // Move the addImage to the left

            doc.setFontSize(7);
            doc.text(resp[0].ProductName, 2, 6);
            doc.setFontSize(6); // Move ProductName below the heading with reduced spacing
            doc.text('Batch No: ' + resp[0].BatchNo, 2, 9); // Put BatchNo below ProductName with reduced spacing
            doc.text('Mfg Dt: ' + resp[0].ManufactureDate, 2, 11);
            doc.text('Exp Dt: ' + resp[0].ExpiryDate, 2, 13);
            doc.text('G.W: '+ resp[0].GW, 17, 16);
            doc.text('Contractor: '+ resp[0].Contractor, 17, 19);
            doc.text('Supervisor: ' + resp[0].Supervisor, 17, 22);
            doc.text('Dt. of Pack: ' + resp[0].DateOfPack, 17, 25);
            // doc.text('G.W: ', 17, 16);
            // doc.text('Contractor: ', 17, 19);
            // doc.text('Supervisor: ' , 17, 22);
            // doc.text('Dt. of Pack: ', 17, 25);
            const fromNoLast4Digits = resp[j].CartonId.substr(5);
            doc.setFontSize(7);
            doc.text(fromNoLast4Digits, 3, 29);
            // doc.text('G.W: ' + resp[0].GW, 21, 18);
            // doc.text('Contractor:' + resp[0].Contractor, 21, 22);
            // doc.text('Supervisor:' + resp[0].Supervisor, 21, 26);
            // doc.text('Dt. of Pack:' + resp[0].DateOfPack, 21, 30);
           
            j++;
            if (resp.length > i)
                doc.addPage();
        }
        return doc;
    }

}